// extracted by mini-css-extract-plugin
module.exports = {"simplePieChart":"simple-pie-chart_simplePieChart___FAjO"};